window.MARID_LIVE_CATALOGUE = [
  {
    "id": "colombia-goat",
    "shopifyId": 8698486980842,
    "name": "Colombia Goat",
    "liveName": "Colombia Goat",
    "category": "beans",
    "country": "Colombia",
    "brew": "espresso",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 69,
    "description": "Specialty Coffee Beans from Colombia EL Embrujo\n\nIn the heart of Colombia, specialty coffee beans from the \"EL Embrujo\" grow at an altitude of 1500 meters above sea level.\n\nThese beans, from the Bourbon variety, are cultivated with utmost care and processed naturally after harvest to enhance their appealing flavors.\n\nWhen tasting \"Goat \" from \"Marid Coffee,\" fig, green apple hints and passion fruit transport you to a world full of freshness.\n\nThe sweetness merges with the rich flavors in every sip, providing an amazing experience. Whether you prepare a drip coffee that reveals the intricate details of its taste or an espresso that enchants your senses with its depth, goat is a wonderful choice for any time of the day.\n\nThe \"Goat \" beans come in bags of 250 grams or 1kg, roasted and packed at \"Marid Coffee\" roastery in Saudi Arabia.\n\nHot Drip Coffee Preparation Method:\n\nCoffee: Colombia - Goat\nAmount: 20 grams\nTemperature: 93 degrees Celsius\nGrind Type: Medium\n\nPouring Steps:\n\n50 ml (for 30 seconds)\n\nUp to 150 ml\n\nUp to 250 ml\n\nExtraction Time: 2:30 minutes",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/WhatsAppImage2026-07-20at2.25.22PM.jpg?v=1784546775"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250g",
          "1kg"
        ]
      }
    ],
    "variants": [
      {
        "id": "46146575794410",
        "title": "250g",
        "price": 69,
        "compareAt": null,
        "available": true,
        "options": [
          "250g"
        ]
      },
      {
        "id": "46146575827178",
        "title": "1kg",
        "price": 207,
        "compareAt": 276,
        "available": true,
        "options": [
          "1kg"
        ]
      }
    ]
  },
  {
    "id": "honduras-coffee-beans-cabanas",
    "shopifyId": 8676124098794,
    "name": "Honduras Coffee Beans - Cabañas",
    "liveName": "Honduras Coffee Beans - Cabañas",
    "category": "beans",
    "country": "Honduras",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 57,
    "description": "Specialty Coffee Beans from Honduras Cabañas \n\nIn the heart of Honduras, where the mountainous terrain of the Marcala region merges with Pacific Ocean climate influence, lies the \"Proyecto Cabañas\" project. Here, specialty coffee beans of the Catuai and Caturra varieties are grown across small familial farms, imparting a cupping notes of chocolate, grapefruit, and hazelnut. These carefully harvested beans are naturally processed on raised beds—rotated every 30 minutes and continuously sorted—to ensure an exceptional coffee experience. Enjoy a perfect cup where each sip reveals hints of milk chocolate and hazelnuts. Experience the finest Honduran coffee where attention is paid to every detail of quality and origin heritage. The specialty coffee from \"Honduras - Proyecto Cabañas Natural\" comes in bags of 250g or 1kg \n\nHot Drip Coffee Preparation Method:\n\n \n\nCoffee: Honduras - Proyecto Cabañas Natural \n\n \n\nAmount: 18 grams\n\nTemperature: 92 degrees Celsius\n\nGrind Type: Medium\n\nPouring Steps:\n\n50 ml (for 30 seconds)\n\nUp to 150 ml\n\nUp to 288 ml\n\nExtraction Time: 2:30 minutes",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/WhatsAppImage2026-06-15at2.51.24PM_183d669e-0b05-48dc-8c4f-67cb505e8a29.jpg?v=1781694095"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250g",
          "1kg"
        ]
      }
    ],
    "variants": [
      {
        "id": "46045531865322",
        "title": "250g",
        "price": 57,
        "compareAt": null,
        "available": true,
        "options": [
          "250g"
        ]
      },
      {
        "id": "46045531898090",
        "title": "1kg",
        "price": 171,
        "compareAt": null,
        "available": true,
        "options": [
          "1kg"
        ]
      }
    ]
  },
  {
    "id": "barista-course-beginner-level-copy",
    "shopifyId": 8598092185834,
    "name": "Barista Course - Beginner Level",
    "liveName": "Barista Course - Beginner Level",
    "category": "courses",
    "country": "Marid",
    "brew": "espresso",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 575,
    "description": "The Barista Course – Beginner Level is a hands-on training program designed to teach participants the essential skills needed to start working as a barista. It focuses on espresso preparation, understanding coffee basics, and operating café equipment with confidence.\n\nCourse Details:Duration: 1 day / 4–6 training hours\n\nCourse Content:\n\nIntroduction to coffee types and grind sizes\n\nOperating and cleaning the espresso machine\n\nExtracting espresso and preparing basic drinks (Espresso – Americano – Cappuccino)\n\nUnderstanding café tools and materials\n\nHygiene, safety, and workstation organization\n\nCourse Objectives:\n\nLearn the fundamentals of espresso extraction\n\nUnderstand the workflow in a café environment\n\nPractice proper machine maintenance and cleaning\n\nGain confidence in preparing consistent, high-quality drinks\n\nAttendees: Open to beginners, coffee enthusiasts, and new café employees\n\nThis course is ideal for anyone taking their first step into the world of coffee and looking to build practical barista skills that meet café standards.\n\nExclusive for participants:Enjoy a free coffee tasting experience at Marid Coffee Roastery, plus 30% off all coffee bags for one month after completing the course.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/968cc9487584b962a9c01101e223a5fd.jpg?v=1762883724"
    ],
    "options": [
      {
        "name": "Date",
        "position": 1,
        "values": [
          "التسجيل العام",
          "August 01 - 2026 10:00 AM",
          "August 08 - 2026 10:00 AM",
          "August 15 - 2026 10:00 AM",
          "August 22 - 2026 10:00 AM",
          "August 29 - 2026 10:00 AM",
          "September 05 - 2026 10:00 AM",
          "September 12 - 2026 10:00 AM",
          "September 19 - 2026 10:00 AM",
          "September 26 - 2026 10:00 AM",
          "October 03 - 2026 10:00 AM",
          "October 10 - 2026 10:00 AM",
          "October 17 - 2026 10:00 AM",
          "October 24 - 2026 10:00 AM",
          "October 31 - 2026 10:00 AM",
          "November 07 - 2026 10:00 AM",
          "November 14 - 2026 10:00 AM",
          "November 21 - 2026 10:00 AM",
          "November 28 - 2026 10:00 AM"
        ]
      }
    ],
    "variants": [
      {
        "id": "46156168757482",
        "title": "التسجيل العام",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "التسجيل العام"
        ]
      },
      {
        "id": "46156172165354",
        "title": "August 01 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "August 01 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46156174000362",
        "title": "August 08 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "August 08 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46156174033130",
        "title": "August 15 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "August 15 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46156174065898",
        "title": "August 22 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "August 22 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46156174098666",
        "title": "August 29 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "August 29 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46156174131434",
        "title": "September 05 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "September 05 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46156174164202",
        "title": "September 12 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "September 12 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46156174196970",
        "title": "September 19 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "September 19 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46156174229738",
        "title": "September 26 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "September 26 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46156174262506",
        "title": "October 03 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "October 03 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46226279039210",
        "title": "October 10 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "October 10 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46226280186090",
        "title": "October 17 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "October 17 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46226315673834",
        "title": "October 24 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "October 24 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46226315772138",
        "title": "October 31 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "October 31 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46226328879338",
        "title": "November 07 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "November 07 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46226328912106",
        "title": "November 14 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "November 14 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46226328944874",
        "title": "November 21 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "November 21 - 2026 10:00 AM"
        ]
      },
      {
        "id": "46226328977642",
        "title": "November 28 - 2026 10:00 AM",
        "price": 575,
        "compareAt": null,
        "available": true,
        "options": [
          "November 28 - 2026 10:00 AM"
        ]
      }
    ]
  },
  {
    "id": "barista-course-beginner-level",
    "shopifyId": 8572738765034,
    "name": "Introduction to the World of Coffee Course",
    "liveName": "Introduction to the World of Coffee Course",
    "category": "courses",
    "country": "Marid",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 450,
    "description": "A comprehensive introductory journey into the world of coffee, starting with its history and geographical origins, passing through the stages of cultivation and harvesting, then processing and roasting, and finally the different methods of preparation.\n\nCourse Details:Duration: 1 day / 4–6 training hours\n\nCourse Content:\n\nThe journey of coffee from farm to cup.\n\nTypes of coffee beans and processing methods.\n\nRoasting levels and their effect on flavor.\n\nThe most popular brewing methods.\n\nA simple tasting session to get acquainted with the flavors.\n\nCourse Objectives: Understanding the important basics in the world of coffee.\n\nAttendees: Open to beginners, coffee enthusiasts, and new café employees\n\nThis course is ideal for anyone taking their first step into the world of coffee and looking to build practical barista skills that meet café standards.\n\nExclusive for participants:Enjoy a free coffee tasting experience at Marid Coffee Roastery, plus 30% off all coffee bags for one month after completing the course.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/968cc9487584b962a9c01101e223a5fd.jpg?v=1762883724"
    ],
    "options": [
      {
        "name": "Ticket type",
        "position": 1,
        "values": [
          "التسجيل العام",
          "October 12 - 2026 05:00 PM",
          "November 23 - 2026 05:00 PM",
          "January 04 - 2027 05:00 PM"
        ]
      }
    ],
    "variants": [
      {
        "id": "46226330550506",
        "title": "التسجيل العام",
        "price": 450,
        "compareAt": null,
        "available": true,
        "options": [
          "التسجيل العام"
        ]
      },
      {
        "id": "46226330583274",
        "title": "October 12 - 2026 05:00 PM",
        "price": 450,
        "compareAt": null,
        "available": true,
        "options": [
          "October 12 - 2026 05:00 PM"
        ]
      },
      {
        "id": "46226330812650",
        "title": "November 23 - 2026 05:00 PM",
        "price": 450,
        "compareAt": null,
        "available": true,
        "options": [
          "November 23 - 2026 05:00 PM"
        ]
      },
      {
        "id": "46226330845418",
        "title": "January 04 - 2027 05:00 PM",
        "price": 450,
        "compareAt": null,
        "available": true,
        "options": [
          "January 04 - 2027 05:00 PM"
        ]
      }
    ]
  },
  {
    "id": "barista-course-intermediate-level",
    "shopifyId": 8572741452010,
    "name": "Barista Course – Intermediate Level",
    "liveName": "Barista Course – Intermediate Level",
    "category": "courses",
    "country": "Marid",
    "brew": "espresso",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 1000,
    "description": "The Barista Course – Intermediate Level is a hands-on advanced training program designed to help participants refine their espresso extraction skills, enhance flavor balance, and focus on the fine details of preparing specialty coffee drinks.This course is built for baristas who are ready to take their craft to the next level of professionalism.\n\nCourse Details:Duration: 2 days / 4–5 training hours per day\n\nCourse Content:\n\nCalibrating espresso extraction according to quality standards\n\nImproving milk steaming skills and achieving flavor balance\n\nUnderstanding the variables that affect taste (grind size – dose – time – temperature)\n\nApplying hygiene practices and preventive maintenance for coffee equipment\n\nCourse Objectives:\n\nDevelop precise control over espresso extraction and flavor consistency\n\nEnhance drink quality and achieve harmony between milk and espresso\n\nGain advanced hands-on experience in steaming and extraction\n\nImprove workflow efficiency and reduce errors in café operations\n\nAttendees:\n\nThose who have completed the Beginner Barista Course\n\nCafé staff seeking to elevate their technical skills\n\nIndividuals aiming to gain deeper experience in extraction and milk texturing\n\nPrerequisites:Completion of the Beginner Barista Course at least 3 months prior, or a minimum of 3 months of practical experience in a café environment.\n\nThis course is ideal for baristas looking to move from basic execution to mastering flavor control and beverage consistency.\n\n Exclusive for participants:Enjoy a special coffee tasting experience at Marid Coffee Roastery, plus 30% off all coffee bags for one month after completing the course",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/6b28261b2d50e45d18e6ec66bd51f14c_506afd6c-e80e-4fd4-9ebc-7f278f862b94.jpg?v=1762883668"
    ],
    "options": [
      {
        "name": "Date",
        "position": 1,
        "values": [
          "October 05 - 2026 05:00 PM",
          "November 16- 2026 05:00 PM",
          "December 28- 2026 05:00 PM"
        ]
      },
      {
        "name": "Ticket",
        "position": 2,
        "values": [
          "دخول عام"
        ]
      }
    ],
    "variants": [
      {
        "id": "46226363941098",
        "title": "October 05 - 2026 05:00 PM / دخول عام",
        "price": 1000,
        "compareAt": null,
        "available": true,
        "options": [
          "October 05 - 2026 05:00 PM",
          "دخول عام"
        ]
      },
      {
        "id": "46226363973866",
        "title": "November 16- 2026 05:00 PM / دخول عام",
        "price": 1000,
        "compareAt": null,
        "available": true,
        "options": [
          "November 16- 2026 05:00 PM",
          "دخول عام"
        ]
      },
      {
        "id": "46226364006634",
        "title": "December 28- 2026 05:00 PM / دخول عام",
        "price": 1000,
        "compareAt": null,
        "available": true,
        "options": [
          "December 28- 2026 05:00 PM",
          "دخول عام"
        ]
      }
    ]
  },
  {
    "id": "latte-art-course-beginner-level",
    "shopifyId": 8572742697194,
    "name": "Latte Art Course – Beginner Level",
    "liveName": "Latte Art Course – Beginner Level",
    "category": "courses",
    "country": "Marid",
    "brew": "espresso",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 650,
    "description": "The Latte Art Course – Beginner Level is a creative, hands-on program designed to teach participants how to create simple coffee art patterns using basic milk texturing and pouring techniques. It’s the perfect introduction to the artistic side of coffee making.\n\nCourse Details:Duration: 1 day / 4–6 training hours\n\nCourse Content:\n\nFundamentals of milk steaming and texturing\n\nUnderstanding milk consistency and temperature control\n\nCreating basic patterns (Heart – Tulip – Rosetta)\n\nEnhancing drink presentation and aesthetics\n\nCourse Objectives:\n\nLearn how to control milk texture and pouring flow\n\nDevelop coordination between espresso and milk for latte art\n\nMaster simple, visually appealing designs for café presentation\n\nAttendees:Open to beginners, coffee lovers, and new café employees interested in learning the basics of milk-based coffee art.\n\nPrerequisites:\n\nBasic knowledge of espresso machine operation\n\nCompletion of the Beginner Barista Course is recommended\n\nThis course is ideal for anyone who wants to learn how to create beautiful latte designs and elevate their coffee presentation skills.\n\n Exclusive for participants:Enjoy a free coffee tasting experience at Marid Coffee Roastery, plus 30% off all coffee bags for one month after completing the course.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/e3ef7ff1c2afd0ba3ab2017b021f57aa.jpg?v=1762883568"
    ],
    "options": [
      {
        "name": "Date",
        "position": 1,
        "values": [
          "September 07 - 2026 05:00 PM",
          "October 19- 2026 05:00 PM",
          "November 30- 2026 05:00 PM"
        ]
      },
      {
        "name": "Ticket",
        "position": 2,
        "values": [
          "General Admission"
        ]
      }
    ],
    "variants": [
      {
        "id": "46226365219050",
        "title": "September 07 - 2026 05:00 PM / General Admission",
        "price": 650,
        "compareAt": null,
        "available": true,
        "options": [
          "September 07 - 2026 05:00 PM",
          "General Admission"
        ]
      },
      {
        "id": "46226367709418",
        "title": "October 19- 2026 05:00 PM / General Admission",
        "price": 650,
        "compareAt": null,
        "available": true,
        "options": [
          "October 19- 2026 05:00 PM",
          "General Admission"
        ]
      },
      {
        "id": "46226367742186",
        "title": "November 30- 2026 05:00 PM / General Admission",
        "price": 650,
        "compareAt": null,
        "available": true,
        "options": [
          "November 30- 2026 05:00 PM",
          "General Admission"
        ]
      }
    ]
  },
  {
    "id": "pour-over-brewing-course-intermediate-level",
    "shopifyId": 8572743614698,
    "name": "Pour-Over Brewing Course – Intermediate Level",
    "liveName": "Pour-Over Brewing Course – Intermediate Level",
    "category": "courses",
    "country": "Marid",
    "brew": "filter",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 1000,
    "description": "Hands-on training designed to help participants refine their pour-over brewing skills by understanding and controlling key variables such as grind size, water temperature, and extraction time. It’s the ideal next step for baristas and coffee professionals aiming to brew with precision and consistency.\n\nCourse Details:\n\nDuration: 2 days / 4–5 training hours per day\n\nCourse Content:\n\nUnderstanding and controlling the main variables that affect extraction\n\nExploring the impact of grind size, water temperature, and brew ratio\n\nTasting and evaluating brews with different extraction levels\n\nImproving brewing precision using various tools and methods\n\nCourse Objectives:\n\nMaster the fundamentals of variable control in pour-over brewing\n\nRecognize how each factor influences flavor and balance\n\nDevelop consistency in brewing quality across different recipes\n\nLearn to evaluate and adjust extraction for optimal results\n\nAttendees:\n\nOpen to baristas and coffee professionals with previous brewing experience, as well as those working in specialty cafés or roasteries who wish to improve brew quality and deepen their technical understanding.\n\nPrerequisites:\n\nCompletion of the Beginner Brewing Course or a minimum of 3 months of brewing experience\n\nCompletion of the Beginner Tasting Course is recommended\n\nExclusive for Participants:\n\nEnjoy a guided tasting experience at Marid Coffee Roastery and receive 30% off all coffee bags for one month after completing the course.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/4767cfb449c4a3214996358b936c98a9.jpg?v=1762883526"
    ],
    "options": [
      {
        "name": "Date",
        "position": 1,
        "values": [
          "September 21- 2026 05:00 PM",
          "November 09 - 2026 05:00 PM",
          "December 21- 2026 05:00 PM"
        ]
      },
      {
        "name": "Ticket",
        "position": 2,
        "values": [
          "General Admission"
        ]
      }
    ],
    "variants": [
      {
        "id": "46156177998058",
        "title": "September 21- 2026 05:00 PM / General Admission",
        "price": 1000,
        "compareAt": null,
        "available": true,
        "options": [
          "September 21- 2026 05:00 PM",
          "General Admission"
        ]
      },
      {
        "id": "46226363384042",
        "title": "November 09 - 2026 05:00 PM / General Admission",
        "price": 1000,
        "compareAt": null,
        "available": true,
        "options": [
          "November 09 - 2026 05:00 PM",
          "General Admission"
        ]
      },
      {
        "id": "46226363416810",
        "title": "December 21- 2026 05:00 PM / General Admission",
        "price": 1000,
        "compareAt": null,
        "available": true,
        "options": [
          "December 21- 2026 05:00 PM",
          "General Admission"
        ]
      }
    ]
  },
  {
    "id": "brewing-course-beginner-level",
    "shopifyId": 8572746563818,
    "name": "Brewing Course – Beginner Level",
    "liveName": "Brewing Course – Beginner Level",
    "category": "courses",
    "country": "Marid",
    "brew": "filter",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 700,
    "description": "The Brewing Course – Beginner Level is an introductory, hands-on program designed to teach participants the fundamental principles of pour-over brewing using popular methods such as V60 and Chemex. This course focuses on understanding the core concepts behind coffee extraction and mastering the steps for consistent, balanced brewing.\n\nCourse Details:\n\nDuration: 1 day / 4–6 training hours\n\nCourse Content:\n\nIntroduction to pour-over tools and equipment\n\nStep-by-step brewing methods using V60 and Chemex\n\nUnderstanding coffee-to-water ratios\n\nPracticing balanced and consistent preparation\n\nCourse Objectives:\n\nLearn the basic principles of coffee extraction\n\nUnderstand how to control key brewing factors\n\nGain confidence in preparing coffee using pour-over tools\n\nBuild a foundation for advanced brewing techniques\n\nAttendees:\n\nOpen to beginners, home brewers, and coffee enthusiasts who want to explore pour-over brewing for the first time or deepen their understanding of extraction basics.\n\nPrerequisites:\n\nA passion for learning coffee brewing methods\n\nExclusive for Participants:\n\nEnjoy a free coffee tasting session at Marid Coffee Roastery and get 30% off all coffee bags for one month after completing the course.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/449ccebad023395760160ec0fa0b66aa.jpg?v=1762883458"
    ],
    "options": [
      {
        "name": "Date",
        "position": 1,
        "values": [
          "November 02 - 2026 05:00 PM",
          "December 14 - 2026 05:00 PM",
          "September 21 - 2026 05:00 PM"
        ]
      },
      {
        "name": "Ticket",
        "position": 2,
        "values": [
          "دخول عام"
        ]
      }
    ],
    "variants": [
      {
        "id": "46226333237482",
        "title": "November 02 - 2026 05:00 PM / دخول عام",
        "price": 700,
        "compareAt": null,
        "available": true,
        "options": [
          "November 02 - 2026 05:00 PM",
          "دخول عام"
        ]
      },
      {
        "id": "46226333270250",
        "title": "December 14 - 2026 05:00 PM / دخول عام",
        "price": 700,
        "compareAt": null,
        "available": true,
        "options": [
          "December 14 - 2026 05:00 PM",
          "دخول عام"
        ]
      },
      {
        "id": "46226341658858",
        "title": "September 21 - 2026 05:00 PM / دخول عام",
        "price": 700,
        "compareAt": null,
        "available": true,
        "options": [
          "September 21 - 2026 05:00 PM",
          "دخول عام"
        ]
      }
    ]
  },
  {
    "id": "tasting-course-beginner-level",
    "shopifyId": 8572747546858,
    "name": "Tasting Course - Beginner Level",
    "liveName": "Tasting Course - Beginner Level",
    "category": "courses",
    "country": "Marid",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 750,
    "description": "The Tasting Course – Beginner Level is an introductory and sensory-focused program designed to help participants understand the fundamentals of coffee tasting and flavor profiling using the internationally recognized Coffee Flavor Wheel. It’s the perfect course for anyone looking to train their palate and appreciate the complexity of coffee flavors.\n\nCourse Details:\n\nDuration: 1 day / 6 training hours\n\nCourse Content:\n\nIntroduction to the basic principles of coffee tasting\n\nUnderstanding the flavor wheel and its categories\n\nPracticing sensory evaluation through guided cupping sessions\n\nIdentifying different taste profiles and textures\n\nCourse Objectives:\n\nLearn to distinguish between acidity, sweetness, and bitterness\n\nUnderstand coffee body, aroma, and flavor balance\n\nPractice proper cupping techniques used by professionals\n\nDevelop sensory awareness to describe coffee flavors accurately\n\nAttendees:\n\nOpen to beginners, coffee lovers, and anyone interested in enhancing their tasting skills and understanding the global coffee flavor wheel.\n\nPrerequisites:\n\nPassion for coffee tasting and exploration\n\nNo prior experience required\n\nExclusive for Participants:\n\nEnjoy a professional cupping session at Marid Coffee Roastery and receive 30% off all coffee bags for one month after completing the course.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/1_a531391b-bb8d-496d-987f-92f87fac2c6d.jpg?v=1762883256"
    ],
    "options": [
      {
        "name": "Date",
        "position": 1,
        "values": [
          "September 14 - 2026 05:00 PM",
          "October 26 - 2026 05:00 PM",
          "December 07 - 2026 05:00 PM"
        ]
      },
      {
        "name": "تذكرة",
        "position": 2,
        "values": [
          "دخول عام"
        ]
      }
    ],
    "variants": [
      {
        "id": "46226368069866",
        "title": "September 14 - 2026 05:00 PM / دخول عام",
        "price": 750,
        "compareAt": null,
        "available": true,
        "options": [
          "September 14 - 2026 05:00 PM",
          "دخول عام"
        ]
      },
      {
        "id": "46226368102634",
        "title": "October 26 - 2026 05:00 PM / دخول عام",
        "price": 750,
        "compareAt": null,
        "available": true,
        "options": [
          "October 26 - 2026 05:00 PM",
          "دخول عام"
        ]
      },
      {
        "id": "46226368135402",
        "title": "December 07 - 2026 05:00 PM / دخول عام",
        "price": 750,
        "compareAt": null,
        "available": true,
        "options": [
          "December 07 - 2026 05:00 PM",
          "دخول عام"
        ]
      }
    ]
  },
  {
    "id": "shipping-protection",
    "shopifyId": 8562085134570,
    "name": "Shipping Protection",
    "liveName": "Shipping Protection",
    "category": "service",
    "country": "Marid",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 0,
    "description": "Protect your order from damage, loss, or theft during shipping.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/protection.png?v=1757246524"
    ],
    "options": [
      {
        "name": "عنوان",
        "position": 1,
        "values": [
          "Default"
        ]
      }
    ],
    "variants": [
      {
        "id": "45537838727402",
        "title": "Default",
        "price": 0,
        "compareAt": null,
        "available": true,
        "options": [
          "Default"
        ]
      }
    ]
  },
  {
    "id": "gift-wrapping",
    "shopifyId": 8562085101802,
    "name": "Gift Wrapping",
    "liveName": "Gift Wrapping",
    "category": "service",
    "country": "Marid",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 0,
    "description": "Add an extra layer of protection to your order with gift wrapping, ensuring it stays safe from damage, loss, or theft during shipping.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/gift-wrapper.png?v=1757246523"
    ],
    "options": [
      {
        "name": "عنوان",
        "position": 1,
        "values": [
          "Default"
        ]
      }
    ],
    "variants": [
      {
        "id": "45537838694634",
        "title": "Default",
        "price": 0,
        "compareAt": null,
        "available": true,
        "options": [
          "Default"
        ]
      }
    ]
  },
  {
    "id": "ethiopia-idido-natural",
    "shopifyId": 7503816065258,
    "name": "Ethiopia Idido Coffee",
    "liveName": "Ethiopia Idido Coffee",
    "category": "beans",
    "country": "Ethiopia",
    "brew": "espresso",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 69,
    "description": "Ethiopia Idido Specialty Coffee:\nEthiopia Idido – Elegance and Enchantment in Every SipSpecialty Coffee Beans from Ethiopia – Idido\n\nIf you are a fan of intricate coffees with floral and fruity notes, Ethiopia Idido is a treasure you cannot miss. Grown at altitudes ranging between 1,950 and 2,300 meters above sea level, Idido beans are carefully nurtured in Ethiopia’s legendary coffee lands. Each bean carries the spirit of its origin, making every cup a true celebration of craftsmanship and nature.\n\nIntroduction to Ethiopia Idido\nEthiopia Idido is one of the specialty coffees known for its distinct fruity character and rich hints of red berries and citrus. Grown in Ethiopia's highlands, Idido coffee is characterized by a smooth and balanced body.It can be brewed using various methods, including filter and espresso, making it ideal for specialty coffee lovers.If you are looking for a unique coffee, Ethiopia Idido is an excellent choice.You can add this coffee to your cart now and enjoy an extraordinary specialty coffee experience.\n\nSpecialty Coffee Cultivation\nIn Idido, farming is not just a profession—it’s a way of life.Idido coffee is a unique type of Ethiopian coffee renowned for its luxury and its special extended fermentation process.These beans belong to the rare Heirloom variety and are cultivated by skilled farmers with a deep bond to their land, ensuring each tree receives meticulous care.After careful handpicking, the beans undergo anaerobic processing, a modern technique that enhances flavor complexity and adds unique layers of character you won't find elsewhere.\n\nThroughout this journey, each bean absorbs the farmers’ dedication and deep knowledge, resulting in a meticulously refined coffee that truly symbolizes Ethiopian excellence.\n\nThe History of Ethiopia Idido\nThe history of Ethiopia Idido traces back to ancient times when Ethiopia was one of the first countries to cultivate coffee.Idido coffee has been grown in Ethiopia’s highlands for centuries, with unique processing methods developed over time to enhance flavor.In 2025, the luxurious Ethiopia Idido coffee was launched by Jarn Roastery, distinguished by its anaerobic natural drying method.You can now purchase this product at a special price and pay using various options, including credit card, Mada, or Apple Pay.\n\nWhy We Love Ethiopia Idido Specialty Coffee\n✔️ Grown at high altitudes in ideal Ethiopian microclimates✔️ Carefully handpicked at peak ripeness✔️ Anaerobically processed to unlock rare flavor profiles✔️ Lively notes of grapes, jasmine, vanilla, and balanced acidity✔️ Freshly roasted at Marid Coffee – Saudi Arabia for maximum quality\n\nA Flavor Journey You’ll Never Forget\nFrom the very first sip, Idido greets you with the lively notes of sweet grapes and delicate jasmine.As you continue, hints of vanilla sweetness unfold, harmoniously balanced by the crisp acidity of ripe grapes, creating a truly enchanting experience.This coffee is perfect for brewing with a drip filter to highlight its flavor complexity.\n\nWhether you prefer brewing it as a drip coffee to reveal its elegant aromas or pulling it as a rich espresso to explore its complexity, Ethiopia Idido always promises a refined and detailed cup.\n\nAt Marid Coffee, we roast and package Ethiopia Idido beans in 250g bags, preserving the freshness and authentic character of every bean.\n\nCultural Significance\nCoffee in Ethiopia is not just a crop—it is an integral part of Ethiopian culture and social life.Ethiopia Idido coffee stands out with its unique flavor profile and rich character, making it a popular choice among specialty coffee enthusiasts.If you are looking for other products you might enjoy, you can visit our products section to explore a variety of specialty coffees.\n\nThank you for being part of the Ethiopian coffee experience!You can copy and share the product link with your friends.We offer multiple payment methods, including Tabby installments and STC Pay, and you can cancel your order anytime.This product is priced at 250 SAR, and you can complete your purchase via Mada, credit card, or other available options.Click the \"Confirm\" button now to finalize your order.\n\nBrewing Guide – Hot Drip Coffee (Recommended)\nCoffee: Ethiopia – IdidoAmount: 18 gramsTemperature: 91°CGrind Size: MediumBag Weight: 250 grams\n\nPouring Steps:\n\n50ml (first 30 seconds)\n\nUp to 150ml (slow pour)\n\nUp to 270ml total\n\nTotal Extraction Time: 2:40 minutes\n\nThe Story Behind Ethiopia Idido Coffee\nCoffee in Ethiopia is not just a crop—it’s a deep cultural heritage.Idido is located near the famous Yirgacheffe region and represents some of the world’s finest environmental and traditional farming practices.Visitors to the farms can even enjoy a free tasting experience upon visiting.\n\nHere, the combination of high elevations, rich soils, and perfect weather creates an ideal environment for growing coffee beans filled with detail and life.\n\nChoosing Ethiopia Idido means celebrating centuries of tradition, the excellence of natural farming, and the artistry of flavor—all in one beautiful cup.\n\nAvailable Now\n✔️ 250g bags — Perfect for pour-over, drip brewing, or even espresso✔️ Freshly roasted at Marid Coffee – Saudi Arabia✔️ Limited availability — Discover the beauty of Ethiopia in every sip",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/M-_0006_idido.jpg?v=1752046076",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/910e7d3eddff075153861d76c74543ca.jpg?v=1752046076",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/side5.jpg?v=1752046076"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250 g",
          "1kg"
        ]
      }
    ],
    "variants": [
      {
        "id": "43380348059882",
        "title": "250 g",
        "price": 69,
        "compareAt": null,
        "available": true,
        "options": [
          "250 g"
        ]
      },
      {
        "id": "44859652571370",
        "title": "1kg",
        "price": 207,
        "compareAt": 276,
        "available": true,
        "options": [
          "1kg"
        ]
      }
    ]
  },
  {
    "id": "indonesia-java",
    "shopifyId": 8276843888874,
    "name": "Indonesia Java",
    "liveName": "Indonesia Java",
    "category": "beans",
    "country": "Indonesia",
    "brew": "espresso",
    "vendor": "مارد القهوة",
    "available": false,
    "price": 69,
    "description": "Specialty Coffee Beans from Java, Indonesia \n\nIn the depths of Indonesia, between the stunning Java mountains, coffee beans that captivate the senses thrive. These beans are grown in an ideal environment, ranging from 1350 to 1450 meters above sea level, giving them unique characteristics.\n\nThe Bourbon variety, considered one of the finest, holds a story of rich nature in each bean. The journey of Java beans begins with farmers who passionately care for them, harvesting the ripe fruits and subjecting them to anaerobic processing.\n\nThis method enhances the complexity of flavors and highlights the unique qualities of each bean. When tasting the Java harvest from Marid Coffee, you will enjoy the sweet notes of candy, the aroma of ripe grapes, and bursts of pomegranate flavor, making you feel the refreshment of nature. These flavors manifest in a wonderful harmony, creating an unforgettable experience from Marid.\n\nThe \"Java\" harvest is considered the perfect choice for those who prefer drip coffee or espresso. With a weight of 250 grams or 1kg bag, it provides you with the opportunity to share this experience with your loved ones or to treat yourself to quiet moments.\n\nThey are roasted and packed with precision and the highest quality in Saudi Arabia at Marid Coffee.\n\nHot Drip Coffee Preparation Method:\n\nCoffee: Indonesia - Java\nAmount: 18grams\nTemperature: 92 degrees Celsius\nGrind Type: Medium\n\nPouring Steps:\n\n50 ml (for 30 seconds)\n\nUp to 150 ml\n\nUp to 288 ml\n\nExtraction Time: 2:30 minutes",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/M-_0005_java.jpg?v=1752047514",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/d2213657bdcdc0048f435fe8fb16faac.jpg?v=1752047560",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/side10.jpg?v=1752047560"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250 g",
          "1kg"
        ]
      }
    ],
    "variants": [
      {
        "id": "44780800311530",
        "title": "250 g",
        "price": 69,
        "compareAt": null,
        "available": false,
        "options": [
          "250 g"
        ]
      },
      {
        "id": "44859648377066",
        "title": "1kg",
        "price": 249,
        "compareAt": null,
        "available": false,
        "options": [
          "1kg"
        ]
      }
    ]
  },
  {
    "id": "option-set-1037006-radio-24",
    "shopifyId": 8518442254570,
    "name": "Colombia Huila Coffee Sample - All-Purpose Roast",
    "liveName": "Columbia Huila Coffee Sample - All Purpose Roast",
    "category": "samples",
    "country": "Colombia",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 12,
    "description": "In southern Colombia, specifically at \"El Diviso\" farm, specialty coffee beans are cultivated in fertile mountain regions at an altitude of 1500 meters above sea level. Grown with care in ideal climatic conditions—where volcanic soil meets gentle sunlight—these beans develop exceptional quality from the root to the harvest.\n\nColombia Huila coffee is known for its well-balanced and complex flavor profile. It combines the natural sweetness of fruits with soft lemon acidity and a heavy body, offering a rich and satisfying cup. The beans are washed processed, a method that enhances clarity and brings out the distinct flavor notes in every sip.\n\nThis coffee is available in 60-gram bags, roasted and packed with precision in Saudi Arabia to ensure top freshness and quality. Thanks to its balanced flavor and refined profile, it is perfect for all brewing methods—whether you prefer drip or manual brewing tools, each cup promises a complete and flavorful experience.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/huila-sample_66e1cc90-5e80-4b2b-813b-090773c1184d.jpg?v=1751354916"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "60g"
        ]
      }
    ],
    "variants": [
      {
        "id": "45028653170922",
        "title": "60g",
        "price": 12,
        "compareAt": null,
        "available": true,
        "options": [
          "60g"
        ]
      }
    ]
  },
  {
    "id": "option-set-1037006-radio-18",
    "shopifyId": 8518442221802,
    "name": "Colombia Huila Coffee Sample - Espresso",
    "liveName": "Colombia Huila Coffee Sample - Espresso",
    "category": "samples",
    "country": "Colombia",
    "brew": "espresso",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 51,
    "description": "",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/huila-sample_66e1cc90-5e80-4b2b-813b-090773c1184d.jpg?v=1751354916"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250 g"
        ]
      }
    ],
    "variants": [
      {
        "id": "45028653072618",
        "title": "250 g",
        "price": 51,
        "compareAt": null,
        "available": true,
        "options": [
          "250 g"
        ]
      }
    ]
  },
  {
    "id": "option-set-1037006-radio-23",
    "shopifyId": 8518442189034,
    "name": "Costa Rica Las Moras Coffee Sample - All-Purpose Roast",
    "liveName": "Costa Rica Las Moras Coffee Sample - All-Purpose Roast",
    "category": "samples",
    "country": "Costa Rica",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 16,
    "description": "",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/las-moras-sample_392d4f9d-95e7-4578-a338-10b8c160d4f2.jpg?v=1751356103"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "60g"
        ]
      }
    ],
    "variants": [
      {
        "id": "45028652974314",
        "title": "60g",
        "price": 16,
        "compareAt": null,
        "available": true,
        "options": [
          "60g"
        ]
      }
    ]
  },
  {
    "id": "option-set-1037006-radio-17",
    "shopifyId": 8518442156266,
    "name": "Costa Rica Las Moras Coffee Sample - Espresso",
    "liveName": "Costa Rica Las Moras Coffee Sample - Espresso",
    "category": "samples",
    "country": "Costa Rica",
    "brew": "espresso",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 69,
    "description": "",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/las-moras-sample_392d4f9d-95e7-4578-a338-10b8c160d4f2.jpg?v=1751356103"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250 g"
        ]
      }
    ],
    "variants": [
      {
        "id": "45028652876010",
        "title": "250 g",
        "price": 69,
        "compareAt": null,
        "available": true,
        "options": [
          "250 g"
        ]
      }
    ]
  },
  {
    "id": "option-set-1037006-radio-21",
    "shopifyId": 8518442057962,
    "name": "Salvador Agua Caliente Coffee Sample - All-Purpose Roast",
    "liveName": "Salvador Agua Caliente Coffee Sample - All-Purpose Roast",
    "category": "samples",
    "country": "El Salvador",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 12,
    "description": "",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/agua-sample_c43210f7-9410-47fe-a307-e5fc09459e38.jpg?v=1751356411"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "60g"
        ]
      }
    ],
    "variants": [
      {
        "id": "45028652581098",
        "title": "60g",
        "price": 12,
        "compareAt": null,
        "available": true,
        "options": [
          "60g"
        ]
      }
    ]
  },
  {
    "id": "option-set-1037006-radio-15",
    "shopifyId": 8518442025194,
    "name": "El Salvador Agua Caliente Coffee Sample - Espresso",
    "liveName": "Salvador Hot Water Coffee Sample - Espresso",
    "category": "samples",
    "country": "El Salvador",
    "brew": "espresso",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 51,
    "description": "",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/agua-sample_c43210f7-9410-47fe-a307-e5fc09459e38.jpg?v=1751356411"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250 g"
        ]
      }
    ],
    "variants": [
      {
        "id": "45028652482794",
        "title": "250 g",
        "price": 51,
        "compareAt": null,
        "available": true,
        "options": [
          "250 g"
        ]
      }
    ]
  },
  {
    "id": "option-set-1037006-radio-26",
    "shopifyId": 8518441992426,
    "name": "Ethiopia Idido coffee Sample - All-Purpose Roast",
    "liveName": "Ethiopia Idido coffee Sample - All-Purpose Roast",
    "category": "samples",
    "country": "Ethiopia",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 16,
    "description": "",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/idido-sample_42176241-7f58-4148-917c-9922a667f797.jpg?v=1751354241"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "60g"
        ]
      }
    ],
    "variants": [
      {
        "id": "45028652384490",
        "title": "60g",
        "price": 16,
        "compareAt": null,
        "available": true,
        "options": [
          "60g"
        ]
      }
    ]
  },
  {
    "id": "option-set-1037006-radio-25",
    "shopifyId": 8518441959658,
    "name": "Ethiopia Idido Coffee Sample - Espresso",
    "liveName": "Ethiopia Idido Coffee Sample - Espresso",
    "category": "samples",
    "country": "Ethiopia",
    "brew": "espresso",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 69,
    "description": "Ethiopia Idido coffee beans are Grown at altitudes between 1,950 and 2,300 meters above sea level, these beans are cultivated with care in one of Ethiopia’s most legendary coffee regions. Each bean reflects the richness of its origin and the essence of nature.\n\nEthiopia Idido stands out with its unique flavor profile, offering vibrant notes of grape, jasmine, and a soft touch of vanilla. With a smooth and balanced body, this specialty coffee is perfectly suited for espresso, delivering a refined and memorable experience in every cup.\n\nAt Marid Coffee, we roast and pack Ethiopia Idido with precision in Saudi Arabia. Available in 250g bags, this coffee is crafted specifically for espresso preparation -ensuring quality, freshness, and exceptional taste in every brew.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/idido-sample.jpg?v=1751286124",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/PHOTO-2025-03-20-02-06-05_2.jpg?v=1751286124"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250 g"
        ]
      }
    ],
    "variants": [
      {
        "id": "45028652286186",
        "title": "250 g",
        "price": 69,
        "compareAt": null,
        "available": true,
        "options": [
          "250 g"
        ]
      }
    ]
  },
  {
    "id": "option-set-1037006-radio-20",
    "shopifyId": 8518441926890,
    "name": "Ethiopia Guji Coffee Sample - All-Purpose Roast",
    "liveName": "عينة القهوة الاثيوبية قوجي - حمصتنا المختارة",
    "category": "samples",
    "country": "Marid",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 13,
    "description": "",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/guji-sample_9e0de9d0-9679-4589-a004-ff7c49cf42f5.jpg?v=1751351518"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "60g"
        ]
      }
    ],
    "variants": [
      {
        "id": "45028652187882",
        "title": "60g",
        "price": 13,
        "compareAt": null,
        "available": true,
        "options": [
          "60g"
        ]
      }
    ]
  },
  {
    "id": "option-set-1037006-radio-14",
    "shopifyId": 8518441894122,
    "name": "Ethiopia Guji Coffee Sample - Espresso",
    "liveName": "Ethiopia Guji Coffee Sample - Espresso",
    "category": "samples",
    "country": "Ethiopia",
    "brew": "espresso",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 57,
    "description": "",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/guji-sample_9e0de9d0-9679-4589-a004-ff7c49cf42f5.jpg?v=1751351518"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250 g"
        ]
      }
    ],
    "variants": [
      {
        "id": "45028652089578",
        "title": "250 g",
        "price": 57,
        "compareAt": null,
        "available": true,
        "options": [
          "250 g"
        ]
      }
    ]
  },
  {
    "id": "option-set-1037006-radio-13",
    "shopifyId": 8518437109994,
    "name": "Brazil Alta Coffee Sample - All-Purpose Roast",
    "liveName": "عينة القهوة البرازيلية ألتا - حمصتنا المختارة",
    "category": "samples",
    "country": "Marid",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 11,
    "description": "",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Alta-sample_fcd77169-1846-4cfc-bf1a-9b486ccc68a0.jpg?v=1751356953"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "60g"
        ]
      }
    ],
    "variants": [
      {
        "id": "45028636885226",
        "title": "60g",
        "price": 11,
        "compareAt": null,
        "available": true,
        "options": [
          "60g"
        ]
      }
    ]
  },
  {
    "id": "option-set-1037006-radio-1",
    "shopifyId": 8518436946154,
    "name": "Brazil Alta Coffee Sample - Espresso",
    "liveName": "عينة القهوة البرازيلية ألتا - اسبريسو",
    "category": "samples",
    "country": "Marid",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 46,
    "description": "",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Alta-sample_fcd77169-1846-4cfc-bf1a-9b486ccc68a0.jpg?v=1751356953"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250 g"
        ]
      }
    ],
    "variants": [
      {
        "id": "45028636229866",
        "title": "250 g",
        "price": 46,
        "compareAt": null,
        "available": true,
        "options": [
          "250 g"
        ]
      }
    ]
  },
  {
    "id": "ethiopia-guji",
    "shopifyId": 8360823062762,
    "name": "Ethiopia Specialty Coffee - Guji",
    "liveName": "Ethiopia Specialty Coffee - Guji",
    "category": "beans",
    "country": "Ethiopia",
    "brew": "espresso",
    "vendor": "Marid Coffee",
    "available": true,
    "price": 57,
    "description": "Guji – Bold and Bright\n\nThis one’s for the flavor seekers.\n\nGrown high in the lush Guji region of southern Ethiopia—over 2,000 meters above sea level—this Ethiopia Specialty Coffee is something truly special. Thanks to rich volcanic soil and perfect weather, every cherry is bursting with life before it’s ever picked.\n\nHandpicked with care, Guji coffee is naturally processed, meaning the beans are dried inside the fruit. This traditional Ethiopian method brings out a juicy sweetness and floral aroma you won’t forget.\n\nSo, what does it taste like?\n Every sip hits with a vibrant splash of sugar, vanilla, and jasmine, followed by a smooth body and just a hint of cocoa. It’s bright, bold, and beautifully balanced—the kind of cup you remember.\n\nBest ways to brew:\n\nWant the clearest flavor? Try a pour-over (V60 or Chemex).\n\nCraving something rich? Go with a Espresso.\n\nFor a cool twist, brew it cold you’ll love how naturally sweet it is.\n\nWhether you’re starting your day or slowing it down, Guji is a go-to for anyone who loves fruity, expressive Ethiopia Specialty Coffee. It’s not just coffee—it’s an experience.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/M-_0008_Guji.jpg?v=1752048272",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/cd73f78f4044bd457580b46c76e9b64c.jpg?v=1752048333",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/side9.jpg?v=1752048333"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250 g",
          "1 kg"
        ]
      }
    ],
    "variants": [
      {
        "id": "44780804702442",
        "title": "250 g",
        "price": 57,
        "compareAt": null,
        "available": true,
        "options": [
          "250 g"
        ]
      },
      {
        "id": "45001459990762",
        "title": "1 kg",
        "price": 171,
        "compareAt": 228,
        "available": true,
        "options": [
          "1 kg"
        ]
      }
    ]
  },
  {
    "id": "guatemala",
    "shopifyId": 8452380426474,
    "name": "Guatemala Classic Coffee - San Marcos",
    "liveName": "Guatemala Classic Coffee - San Marcos",
    "category": "beans",
    "country": "Guatemala",
    "brew": "espresso",
    "vendor": "مارد القهوة",
    "available": false,
    "price": 46,
    "description": "Specialty Classic Coffee Beans from Guatemala – San Marcos\n\nNestled in the heart of Guatemala, where breathtaking landscapes meet perfect altitudes, lies the “San Marcos” farm. At elevations ranging from 1400 to 1800 meters above sea level, the “Sarchimor” coffee beans thrive, enriched by fertile soils and ideal climatic conditions.\n\nThese specialty beans are characterized by classic notes of chocolate and hazelnut, meticulously washed to preserve their authentic flavors.\n\nWhether you prefer drip coffee or espresso, every cup delivers a rich and unique experience. At “Marid Coffee,” we ensure that each batch is roasted and packed with exceptional care to bring you the finest quality.\n\nGuatemala – San Marcos coffee comes in 250 gram or 1kg bags, featuring whole beans freshly roasted in our roastery in Saudi Arabia to deliver an extraordinary coffee journey.\n\nHot Drip Coffee Preparation Method:\n\nCoffee: Ethiopia - Uraga\nAmount: 18 grams\nTemperature: 91 degrees Celsius\nGrind Type: Medium\n\nPouring Steps:\n\n50 ml (for 30 seconds)\n\nUp to 150 ml\n\nUp to 288 ml\n\nExtraction Time: 2:30 minutes",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/M-_0002_san_marcos.jpg?v=1752048539",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/side4.jpg?v=1752048539",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/b94211585dfffa69e6005777feb35f63.jpg?v=1752048539"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250g",
          "1kg"
        ]
      }
    ],
    "variants": [
      {
        "id": "44857212993770",
        "title": "250g",
        "price": 46,
        "compareAt": null,
        "available": false,
        "options": [
          "250g"
        ]
      },
      {
        "id": "44859603976426",
        "title": "1kg",
        "price": 166,
        "compareAt": null,
        "available": false,
        "options": [
          "1kg"
        ]
      }
    ]
  },
  {
    "id": "colombia-la-recottei",
    "shopifyId": 8441531072746,
    "name": "Colombia Coffee - La Recotti",
    "liveName": "Colombia Coffee - La Recotti",
    "category": "beans",
    "country": "Colombia",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 80,
    "description": "Nestled among the enchanting Colombian mountains, 'La Ricoti' farm produces specialty coffee beans at an altitude of 1,950 meters. These beans are cultivated with passion and dedication, featuring a unique honey-strawberry processing method that blends the sweetness of strawberries with smooth vanilla undertones. Each sip offers a journey into the world of Colombian coffee, showcasing a harmonious blend of nature's quality and expert craftsmanship. Experience the essence of 'La Ricoti' beans through Marid Coffee,where unparalleled quality meets artisanal skill.\n\nHot Drip Coffee Preparation Method:\n\nCoffee: Colombia - La Ricoti\nAmount: 20 grams\nTemperature: 93 degrees Celsius\nGrind Type: Medium\n\nPouring Steps:\n\n50 ml (for 40 seconds)\n\nUp to 150 ml\n\nUp to 300 ml\n\nExtraction Time: 3:30 minutes",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/la-recotti.jpg?v=1752165802",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/side13.jpg?v=1752165802",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Premium7.jpg?v=1752165802",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Premium5.jpg?v=1752165802",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Premium6.jpg?v=1752165802"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250g"
        ]
      }
    ],
    "variants": [
      {
        "id": "44828586639594",
        "title": "250g",
        "price": 80,
        "compareAt": null,
        "available": true,
        "options": [
          "250g"
        ]
      }
    ]
  },
  {
    "id": "ethiopia-guji-box-5-envelopes",
    "shopifyId": 8433540169962,
    "name": "Ethiopia Guji Box - 5 Envelopes",
    "liveName": "Ethiopia Guji Box - 5 Envelopes",
    "category": "envelopes",
    "country": "Ethiopia",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 30,
    "description": "Weight: 15 grams/envelope.\nTotal Weight: 75 grams.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Guji5EnvelopesBox.jpg?v=1727873312",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Guji-5-Envelopes-Box-V2.jpg?v=1727873341",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Envalops-Usage_6678011d-765d-4af8-a7f2-4ac7addce13f.jpg?v=1727870740",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/steps.png?v=1727870767"
    ],
    "options": [
      {
        "name": "عنوان",
        "position": 1,
        "values": [
          "Default Title"
        ]
      }
    ],
    "variants": [
      {
        "id": "44798319100138",
        "title": "Default Title",
        "price": 30,
        "compareAt": null,
        "available": true,
        "options": [
          "Default Title"
        ]
      }
    ]
  },
  {
    "id": "colombia-huila-box-5-envelopes",
    "shopifyId": 8433528275178,
    "name": "Colombia Huila Box - 5 Envelopes",
    "liveName": "Colombia Huila Box - 5 Envelopes",
    "category": "envelopes",
    "country": "Colombia",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 26,
    "description": "Weight: 15 grams/envelope.\nTotal Weight: 75 grams.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Huila-5-Envelopes-Box.jpg?v=1727870722",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Huila-5-Envelopes-Box-V2.jpg?v=1727870705",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Envalops-Usage_6678011d-765d-4af8-a7f2-4ac7addce13f.jpg?v=1727870740",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/steps.png?v=1727870767"
    ],
    "options": [
      {
        "name": "عنوان",
        "position": 1,
        "values": [
          "Default Title"
        ]
      }
    ],
    "variants": [
      {
        "id": "44798297637098",
        "title": "Default Title",
        "price": 26,
        "compareAt": null,
        "available": true,
        "options": [
          "Default Title"
        ]
      }
    ]
  },
  {
    "id": "20",
    "shopifyId": 8426756505834,
    "name": "Ethiopia Guji Box - 20 Envelopes",
    "liveName": "صندوق قهوة إثيوبيا قوجي – 20 ظرفًا",
    "category": "envelopes",
    "country": "Marid",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 130,
    "description": "",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/2_a910378c-7a10-4058-954a-9e3d82fc2dff.jpg?v=1726483109",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/b26839fbe8e1be968599ec5ddbd4b336.jpg?v=1726483109",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Envalops-Usage_e26196cb-b6c6-4756-9592-d8bbcaa3ee64.jpg?v=1727870188",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/steps_aef46aee-1a08-4c9c-a31c-4f79ca972612.png?v=1727873768"
    ],
    "options": [
      {
        "name": "عنوان",
        "position": 1,
        "values": [
          "Default Title"
        ]
      }
    ],
    "variants": [
      {
        "id": "44779510890730",
        "title": "Default Title",
        "price": 130,
        "compareAt": null,
        "available": true,
        "options": [
          "Default Title"
        ]
      }
    ]
  },
  {
    "id": "10-1",
    "shopifyId": 8426756079850,
    "name": "Ethiopia Guji Box - 10 Envelopes",
    "liveName": "Ethiopia Guji Box - 10 Envelopes",
    "category": "envelopes",
    "country": "Ethiopia",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 57,
    "description": "Weight: 15 grams/envelope.\nTotal Weight: 150 grams.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/0db2ac957bc9111239233a1abc733e3f.jpg?v=1728888393",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/2_a910378c-7a10-4058-954a-9e3d82fc2dff.jpg?v=1726483109",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/b26839fbe8e1be968599ec5ddbd4b336.jpg?v=1726483109",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Envalops-Usage.jpg?v=1727870056",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/steps_f17bd8df-938e-46f4-ab0c-5318cce2ba08.png?v=1727873689"
    ],
    "options": [
      {
        "name": "عنوان",
        "position": 1,
        "values": [
          "Default Title"
        ]
      }
    ],
    "variants": [
      {
        "id": "44779510202602",
        "title": "Default Title",
        "price": 57,
        "compareAt": null,
        "available": true,
        "options": [
          "Default Title"
        ]
      }
    ]
  },
  {
    "id": "10",
    "shopifyId": 8426755490026,
    "name": "Colombia Huila Box - 10 Envelopes",
    "liveName": "Columbia Huila Envelope Box - 10 Envelopes",
    "category": "envelopes",
    "country": "Colombia",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 51,
    "description": "",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/e807b8ee08ff5e92d4ff00aa76bce470_ac635e2a-0d54-4331-ab28-23ee2bdad826.jpg?v=1728888243",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/2_a910378c-7a10-4058-954a-9e3d82fc2dff.jpg?v=1726483109",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/b26839fbe8e1be968599ec5ddbd4b336.jpg?v=1726483109",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Envalops-Usage_9938d79f-9758-4bfd-97a0-26c36143dce3.jpg?v=1727870170",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/steps_6511c748-e305-4f05-8b2d-0b4021d57239.png?v=1727873670"
    ],
    "options": [
      {
        "name": "عنوان",
        "position": 1,
        "values": [
          "Default Title"
        ]
      }
    ],
    "variants": [
      {
        "id": "44779507712234",
        "title": "Default Title",
        "price": 51,
        "compareAt": null,
        "available": true,
        "options": [
          "Default Title"
        ]
      }
    ]
  },
  {
    "id": "saudi-arabia-jibal-al-arda",
    "shopifyId": 8418006761706,
    "name": "Saudi Arabia Specialty Coffee - Jibal Al Arda",
    "liveName": "Saudi Arabia Specialty Coffee - Jibal Al Arda",
    "category": "beans",
    "country": "Saudi Arabia",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 70,
    "description": "The distinctive coffee beans, planted and picked by Saudi hands, were also selected and roasted by Saudi hands to offer those who love new, distinctive, and diverse specialty coffee experiences the most unique and complex suggestions, and an excellent mood that delights with every drop!\n\nHot Drip Coffee Preparation Method:\n\nCoffee: Saudi - Jibal Alarda \n• Quantity: 20 grams \n• Temperature: 91°C\n• Grind type: Medium\n\nPouring steps: \n1. 45ml for 45 seconds\n2. up to: 150ml\n3. up to: 250ml\n4. up to: 300ml\n\nExtraction time: 2 minutes 30 seconds",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/M-_0001_Saudi_-_Edited.jpg?v=1758091825",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/03221fa6792e65d3cf964706e85e6c44.jpg?v=1758091825",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/side12.jpg?v=1758091825",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Premium8.jpg?v=1758091825",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Premium4.jpg?v=1758091825",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Premium3.jpg?v=1758091825"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "125 g"
        ]
      }
    ],
    "variants": [
      {
        "id": "44780791529706",
        "title": "125 g",
        "price": 70,
        "compareAt": 70,
        "available": true,
        "options": [
          "125 g"
        ]
      }
    ]
  },
  {
    "id": "el-salvador-agua-caliante",
    "shopifyId": 8170404151530,
    "name": "Coffee Salvador - Agua Caliente",
    "liveName": "Coffee Salvador - Agua Caliente",
    "category": "beans",
    "country": "El Salvador",
    "brew": "espresso",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 51,
    "description": "Specialty Coffee from Agua Caliante, El Salvador.\n\nThe \"Agua Caliante\" specialty coffee beans, belonging to Marid Coffee's classic harvest category, tell their story from the heart of El Salvador. Grown at an altitude of over 1300 meters above sea level, these beans benefit from ideal conditions that foster the growth of renowned Bourbon beans. \n\nProcessed with a washed method, they present a thick body and hints of luxurious chocolate that tantalize your senses, creating a rich texture that lingers in your memory. Because \"your mood deserves it,\" let this coffee transport you to the beautiful mountains of El Salvador. \n\nThis specialty crop is suitable for both drip coffee and espresso, available in 250-gram or 1Kg bags, roasted and packed in Saudi Arabia by \"Marid Coffee\" to guarantee an unparalleled coffee experience.\n\nHot Drip Coffee Preparation Method:\n\nCoffee: Salvador - Agua Caliante\nAmount: 18 grams\nTemperature: 92 degrees Celsius\nGrind Type: Medium\n\nPouring Steps:\n\n50 ml (for 30 seconds)\n\nUp to 150 ml\n\nUp to 288ml\n\nExtraction Time: 2:30 minutes",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/M-_0011_agua.jpg?v=1752048194",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/1c4bbafc42c1ae3321f6da0d8a7f4414.jpg?v=1752048194",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/side1.jpg?v=1752048194"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250 g",
          "1kg"
        ]
      }
    ],
    "variants": [
      {
        "id": "44780798738666",
        "title": "250 g",
        "price": 51,
        "compareAt": null,
        "available": true,
        "options": [
          "250 g"
        ]
      },
      {
        "id": "44859633533162",
        "title": "1kg",
        "price": 153,
        "compareAt": 204,
        "available": true,
        "options": [
          "1kg"
        ]
      }
    ]
  },
  {
    "id": "costa-rica-la-pascuala-natural",
    "shopifyId": 8126097228010,
    "name": "Costa Rica Las Moras",
    "liveName": "Costa Rica Las Moras",
    "category": "beans",
    "country": "Costa Rica",
    "brew": "espresso",
    "vendor": "Marid Coffee",
    "available": true,
    "price": 69,
    "description": "Specialty Coffee Beans from Las Moras, Costa Rica\n\nIn the heart of Costa Rica, the specialty coffee beans from \"Las Moras\" grow at an altitude of 1600 meters above sea level, benefiting from the ideal climate and rich soil to create optimal conditions that allow each bean to carry the environment's character.\n\nThe journey of \"Las Moras\" coffee begins with supreme commitment and care, as its processing after harvest is truly an art itself.\n\nAfter meticulous harvesting, the coffee beans undergo anaerobic processing, enriching their flavor complexity while allowing them to mature in an atmosphere of tranquility.\n\nWhen tasting \"Las Moras,\" your senses are greeted with the aroma of fresh apples and ripe figs, while the notes of vanilla envelop the surroundings.\n\nWith every sip, the flavors harmonize beautifully: the fresh sweetness of apples and the delicate acidity of figs complement the delightful hints of vanilla.\n\nThe beans of \"Las Moras\" are perfect for both drip coffee and espresso, coming in bags of 250 grams or 1kg, roasted and packed in Saudi Arabia by \"Marid Coffee.\"\n\nCoffee: Costa Rica - Las Moras\nAmount: 18 grams\nTemperature: 93 degrees Celsius\nGrind Type: Medium\n\nPouring Steps:\n\n50 ml (for 30 seconds)\n\nUp to 150 ml\n\nUp to 288 ml\n\nExtraction Time: 2:30 minutes",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/M-_0004_Las_moras.jpg?v=1752047165",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/1ae427bc753fa71ef6110c7111420078.jpg?v=1752047210",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/side7.jpg?v=1752047210"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250g",
          "1kg"
        ]
      }
    ],
    "variants": [
      {
        "id": "44780798476522",
        "title": "250g",
        "price": 69,
        "compareAt": null,
        "available": true,
        "options": [
          "250g"
        ]
      },
      {
        "id": "44859648737514",
        "title": "1kg",
        "price": 207,
        "compareAt": 276,
        "available": true,
        "options": [
          "1kg"
        ]
      }
    ]
  },
  {
    "id": "yemen-hraz",
    "shopifyId": 8012028215530,
    "name": "Yemen Coffee - Haraz (V60)",
    "liveName": "Yemen Coffee - Haraz (V60)",
    "category": "beans",
    "country": "Yemen",
    "brew": "filter",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 70,
    "description": "Specialty Coffee Beans from Haraz, Yemen.\n\nFrom the heart of the towering Haraz mountains in Yemen, where the clouds intertwine with the peaks, coffee beans are grown in the \"Haraz\" farm, a Typica variety between 2600 and 2950 meters above sea level. \n\nFarmers carefully collect the ripe coffee beans with each harvest season, which are then processed anaerobically to enhance the unique qualities that allow each bean to carry the earth's heritage and nature, gaining a new depth in its hints. When you taste the distinguished Haraz harvest from Marid Coffee, your senses are greeted with hints of olive, pineapple, and pear, conveying a feeling of refreshment. \n\nWith each sip, the balance of flavors becomes clearer: the fresh sweetness of pineapple and the subtle acidity of pear merge with touches of olive, adding extra depth. The \"Haraz\" beans come in a weight of 125 grams, perfect for preparing drip coffee that takes you on a journey to the mountains of Yemen, where nature meets passion to create a luxurious cup of coffee. \n\nHaraz Yemen Coffee… Straight from the Heart!\n\n\n  \n  \n\nAbout the Yamen Coffee\nYemeni specialty coffee is a unique type of coffee made from the freshest and most flavorful beans. Each batch is roasted daily upon order, with meticulous attention to detail to ensure unparalleled taste and quality. Our coffee always reaches our customers fresh and full of character, making every cup a unique experience. Adding it to your cart means embarking on a journey to the heart of Yemen with every sip. Due to high demand, it often sells out quickly.\n\nThe History of Coffee in Yemen\nThe origins of Yemeni coffee date back centuries, with Yemeni farmers cultivating and preparing some of the earliest traditional coffee varieties. Their love for coffee influenced neighboring regions, establishing Yemen as a hub for the coffee bean trade. Early farmers played a pivotal role in spreading the love for coffee worldwide, making Yemeni coffee an integral part of global coffee history.\n\nYemen Coffee Features\nOur Yemeni specialty coffee stands out for its unparalleled quality, with carefully selected fresh beans to ensure the best flavor. Each batch is roasted daily upon order, guaranteeing freshness and full character upon arrival.\n\nOur unique packaging uses a one-way valve specifically designed to maintain the coffee’s freshness, ensuring it reaches you at its peak. Our beans are rich with a complex blend of delightful notes, including cinnamon, spices, and raisins, making every cup a unique experience.\n\nWe guarantee the quality of our coffee—it’s not just good; it’s the best choice for specialty coffee enthusiasts. Adding it to your cart means experiencing Yemen with every sip.\n\nYemen Coffee Quality Certifications.\nOur Yemeni specialty coffee is certified by coffee experts, ensuring you receive a high-quality product. Quality is checked daily to guarantee it reaches our customers at its best.\n\nWe are committed to delivering top-quality coffee and continuously strive to enhance our products. Customer satisfaction is our ultimate goal, and we aim to exceed expectations by offering coffee that fulfills their desires. Thank you for being part of our journey in providing the finest Yemeni specialty coffee.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/M-_0000_yemen_harraz.jpg?v=1752045662",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/c9ed08e129dafcde21dd97c1bcd52977.jpg?v=1752045662",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/side11.jpg?v=1752045662",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Premium9.jpg?v=1752065736",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Premium2.jpg?v=1752065736",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/Premium1.jpg?v=1752065736"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "125 g"
        ]
      }
    ],
    "variants": [
      {
        "id": "44780791398634",
        "title": "125 g",
        "price": 70,
        "compareAt": null,
        "available": true,
        "options": [
          "125 g"
        ]
      }
    ]
  },
  {
    "id": "brazil-rosa-branca",
    "shopifyId": 7877876351210,
    "name": "Brazil Coffee Beans - Alta",
    "liveName": "Brazil Coffee Beans - Alta",
    "category": "beans",
    "country": "Brazil",
    "brew": "espresso",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 46,
    "description": "Specialty Coffee Beans from Brazil Alta\n\nIn the heart of Brazil, where sunlight merges with fertile soil, lies the \"Alta\" farm.\n\nHere, specialty coffee beans grow at an altitude of 1200 meters above sea level, imparting notes of hazelnut and chocolate with a heavy body.\n\nThese carefully mixed beans are naturally processed to ensure an exceptional coffee experience. Enjoy a perfect cup for drip or espresso, where each sip reveals hints of hazelnut and dark chocolate.\n\nExperience the finest Brazilian coffee with \"Marid Coffee,\" where we pay attention to every detail in roasting and quality.\n\nThe specialty coffee from \"Brazil -Alta\" comes in bags of 250 or 1kg, with each bag containing whole coffee beans roasted and packed with precision and the highest quality in Saudi Arabia.\n\nHot Drip Coffee Preparation Method:\n\nCoffee: Brazil- Alta\nAmount: 18 grams\nTemperature: 92 degrees Celsius\nGrind Type: Medium\n\nPouring Steps:\n\n50 ml (for 30seconds)\n\nUp to 150 ml\n\nUp to 288ml\n\nExtraction Time: 2:30 minutes",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/M-_0010_Alta.jpg?v=1752046521",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/65b25a1a2e0ed5c510fd2fe47e41bf98.jpg?v=1752046616",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/side6.jpg?v=1752046616"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250 g",
          "1kg"
        ]
      }
    ],
    "variants": [
      {
        "id": "43366825525482",
        "title": "250 g",
        "price": 46,
        "compareAt": null,
        "available": true,
        "options": [
          "250 g"
        ]
      },
      {
        "id": "44859604009194",
        "title": "1kg",
        "price": 138,
        "compareAt": 184,
        "available": true,
        "options": [
          "1kg"
        ]
      }
    ]
  },
  {
    "id": "colombia-huila",
    "shopifyId": 7778331492586,
    "name": "Colombia Huila",
    "liveName": "Colombia Huila",
    "category": "beans",
    "country": "Colombia",
    "brew": "espresso",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 51,
    "description": "Specialty Coffee Beans from Colombia Huila.\n\nIn the heart of Colombia, where sunlight merges with fertile soil, lies \"El Diviso\" farm. Here, specialty coffee beans grow at an altitude of 1500 meters above sea level, imparting notes of fruity, sugar sweetness and soft Lemon acidity with a heavy body. \n\nThese beans are washed processed to ensure an exceptional coffee experience. Enjoy a perfect cup for drip or espresso, where each sip reveals hints of sweet fruits and light lemon acidity. Experience the finest Colombian coffee with \"Marid Coffee,\" where we pay attention to every detail in roasting and quality. \n\nThe specialty coffee from \"Colombia —Huila \" comes in 250-gram or 1Kg bags, each containing whole coffee beans roasted and packed with precision and the highest quality in Saudi Arabia. \n\nHot Drip Coffee Preparation Method:\n\nCoffee: Colombia - Huila\nAmount: 18 grams\nTemperature: 92 degrees Celsius\nGrind Type: Medium\n\nPouring Steps:\n\n50 ml (for 30seconds)\n\nUp to 150 ml\n\nUp to 288ml\n\nExtraction Time: 2:30 minutes",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/M-_0007_huila_ab71150e-0474-41ee-abba-1b277e63cb24.jpg?v=1752046977",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/a2b8a1a90c10b6261d1b7ff5b6ba1d0e.jpg?v=1752047041",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/side8.jpg?v=1752047041"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250 g",
          "1kg"
        ]
      }
    ],
    "variants": [
      {
        "id": "44780797264106",
        "title": "250 g",
        "price": 51,
        "compareAt": null,
        "available": true,
        "options": [
          "250 g"
        ]
      },
      {
        "id": "44859624816874",
        "title": "1kg",
        "price": 153,
        "compareAt": 204,
        "available": true,
        "options": [
          "1kg"
        ]
      }
    ]
  },
  {
    "id": "product-28",
    "shopifyId": 7667862634730,
    "name": "Burlap Bag",
    "liveName": "Burlap Bag",
    "category": "equipment",
    "country": "Marid",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 20,
    "description": "A sack made of burlap",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/products/page-0001.jpg?v=1678274916",
      "https://cdn.shopify.com/s/files/1/1088/3524/products/DSC_4403_1.jpg?v=1678274916",
      "https://cdn.shopify.com/s/files/1/1088/3524/products/DSC_4444_2.jpg?v=1678274916"
    ],
    "options": [
      {
        "name": "عنوان",
        "position": 1,
        "values": [
          "Default Title"
        ]
      }
    ],
    "variants": [
      {
        "id": "42745753207018",
        "title": "Default Title",
        "price": 20,
        "compareAt": null,
        "available": true,
        "options": [
          "Default Title"
        ]
      }
    ]
  },
  {
    "id": "marid-red-travel-tumbler-12-oz",
    "shopifyId": 8736435568874,
    "name": "Marid Red Travel Tumbler — 12 oz",
    "liveName": "Marid Red Travel Tumbler - 12 oz",
    "category": "equipment",
    "country": "Marid",
    "brew": "omni",
    "vendor": "مارد القهوة",
    "available": true,
    "price": 35,
    "description": "Marid red reusable travel tumbler with black flip-top lid. Capacity: 12 oz. Available as a regular product and as one optional referral benefit instead of the 10% friend discount. Subject to availability.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/marid-red-travel-tumbler-12oz-studio-v1.webp?v=1788889703"
    ],
    "options": [
      {
        "name": "Title",
        "position": 1,
        "values": [
          "Default Title"
        ]
      }
    ],
    "variants": [
      {
        "id": "46252486459626",
        "title": "Default Title",
        "price": 35,
        "compareAt": null,
        "available": true,
        "options": [
          "Default Title"
        ]
      }
    ]
  },
  {
    "id": "mblend",
    "shopifyId": 6742996934,
    "name": "M Espresso Coffee Blend",
    "liveName": "M Espresso Coffee Blend",
    "category": "beans",
    "country": "House Blend",
    "brew": "espresso",
    "vendor": "Marid Coffee",
    "available": true,
    "price": 51,
    "description": "Our Espresso M Blend: the Optimal Drink Our special blend\n\n\"Espresso Blend,\" is the perfect choice for espresso and milk drinks, making it one of our best-selling products.\n\nIt features a balanced flavor and a full body, offering notes of chocolate with sweetness and a backdrop of light lemon acidity.\n\nThe flavors shine through when used in milk-based beverages, harmonizing beautifully with the sweetness of the milk without being overpowering.\n\nPreparation Method: Water temperature: 94 degrees Celsius. Extract 36-40 grams of espresso from 18-20 grams of ground coffee with a brew time of 25-35 seconds.",
    "images": [
      "https://cdn.shopify.com/s/files/1/1088/3524/files/M-_0003_Mblend.jpg?v=1752045811",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/0fbc09bb34b5a30c66aa5a44d9745d7c_bf347a56-9e07-4df4-8a75-96f457597d60.jpg?v=1752045870",
      "https://cdn.shopify.com/s/files/1/1088/3524/files/side2.jpg?v=1752045870"
    ],
    "options": [
      {
        "name": "الحجم",
        "position": 1,
        "values": [
          "250 g",
          "1 kg"
        ]
      }
    ],
    "variants": [
      {
        "id": "21272331078",
        "title": "250 g",
        "price": 51,
        "compareAt": null,
        "available": true,
        "options": [
          "250 g"
        ]
      },
      {
        "id": "36399384756392",
        "title": "1 kg",
        "price": 153,
        "compareAt": 204,
        "available": true,
        "options": [
          "1 kg"
        ]
      }
    ]
  }
];

window.MARID_LIVE_CATALOGUE.push({
  id: "uganda-manansi", shopifyId: 8775352090858,
  name: "Uganda Manansi", liveName: "Uganda Manansi",
  category: "beans", country: "Uganda", brew: "filter", vendor: "Marid Coffee",
  available: true, price: 69,
  description: "A vibrant natural process coffee from Uganda, grown at around 1,900 meters above sea level.\n\nMananasi is a fruit forward cup with a sweet and juicy character, combining bright pineapple and delicate pear notes with a smooth chocolate finish.\n\nNaturally processed to preserve its expressive fruit character, this coffee is a great choice for anyone who enjoys clean, sweet and aromatic coffees with a tropical touch.\n\nOrigin: Uganda\nRegion: Mananasi\nAltitude: 1,900 MASL\nProcess: Natural\nTasting Notes: Pineapple · Pear · Chocolate\nRecommended for: Filter coffee, V60, Chemex, AeroPress and other manual brewing methods.",
  images: ["https://maridcoffee.com/cdn/shop/files/manansi.png?v=1791450786"],
  options: [{ name: "Size", position: 1, values: ["250g", "1kg"] }],
  variants: [
    { id: "46364507013354", title: "250g", price: 69, compareAt: null, available: true, options: ["250g"] },
    { id: "46364507046122", title: "1kg", price: 207, compareAt: null, available: true, options: ["1kg"] }
  ]
});
